<template>

	<div class="portlet box blue" v-if="classLevel === 'Bercario' || classLevel === 'Infantil'">

		<div class="portlet-title">

			<div class="caption">
				<i class="fa fa-coffee" aria-hidden="true"></i>
				<span v-translate>Água e/ou suco</span>
			</div>

		</div>


		<div class="portlet-body text-center p-b-0">

			<div class="mt-radio-inline">

				<label v-for="(value, key) in quantityType" class="mt-radio mt-radio-outline">

					<input type="radio" name="water-quantity" :value="key" :checked="key === water" @change="putAgendaWater">
					{{ value }}
					<span></span>

				</label>

			</div>

		</div>

	</div>

</template>

<script>

	import StudentWater from './';
	export default StudentWater;

</script>



// WEBPACK FOOTER //
// water.vue?5485ff86